import { createFileRoute } from "@tanstack/react-router";
import { ShieldAlert } from "lucide-react";

import { Alert, AlertDescription, AlertTitle } from "~/components/ui/alert";
import { Skeleton } from "~/components/ui/skeleton";
import { useEmployeePermissions } from "~/hooks/use-employee-permissions";
import { toConvexTableId } from "~/lib/convex-table-id";

import { LocationTipsSettingsForm } from "../../../../components/tips/tips-settings-form";

export const Route = createFileRoute("/_authenticated/locations/$id/tips")({
  component: LocationTipsSettingsPage,
});

function LocationTipsSettingsPage() {
  const { id } = Route.useParams();
  const { hasPermission, isLoading, hasEmployee } = useEmployeePermissions();
  const canViewIntegrations = hasPermission("viewIntegrations");

  // Loading state
  if (isLoading) {
    return <Skeleton className="h-96 w-full" />;
  }

  // No employee record linked
  if (!hasEmployee) {
    return (
      <Alert>
        <ShieldAlert className="h-4 w-4" />
        <AlertTitle>No Employee Profile</AlertTitle>
        <AlertDescription>
          Your account is not linked to an employee profile. Contact your
          organization admin to set up your employee record with the appropriate
          permissions.
        </AlertDescription>
      </Alert>
    );
  }

  // No permission to view tip settings
  if (!canViewIntegrations) {
    return (
      <Alert variant="destructive">
        <ShieldAlert className="h-4 w-4" />
        <AlertTitle>Access Denied</AlertTitle>
        <AlertDescription>
          You don't have permission to view tip settings. Contact your manager
          to request access.
        </AlertDescription>
      </Alert>
    );
  }

  return (
    <LocationTipsSettingsForm locationId={toConvexTableId("locations", id)} />
  );
}
